document.addEventListener('DOMContentLoaded', function() {
    const openButtons = document.querySelectorAll('.js-open-product-drawer');
    const scrollLeftButtons = document.querySelectorAll('.js-scroll-left');
    const scrollRightButtons = document.querySelectorAll('.js-scroll-right');
    const productDrawers = document.querySelectorAll('.product-drawer-overlay');

    function toggleDrawer() {
        const html = document.documentElement;
        const drawerOverlay = document.querySelector('.product-drawer-overlay.active');
        
        if (drawerOverlay && drawerOverlay.classList.contains('active')) {
            html.classList.add('drawer-open');
        } else {
            html.classList.remove('drawer-open');
        }
    }

    openButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const lookbookId = this.dataset.lookbookId;
        const drawer = document.getElementById(`product-drawer-${lookbookId}`);
        drawer.classList.add('active');
        toggleDrawer();
      });
    });

    productDrawers.forEach(drawer => {
        drawer.addEventListener('click', function(e) {
          if (e.target === this || e.target.classList.contains('product-drawer-background')) {
            this.classList.remove('active');
            toggleDrawer();
          }
        });
    
        // Prevent clicks inside the drawer content from closing the drawer
        const drawerContent = drawer.querySelector('.product-drawer-content');
        if (drawerContent) {
          drawerContent.addEventListener('click', function(e) {
            e.stopPropagation();
          });
        }
      });

    scrollLeftButtons.forEach(button => {
        button.addEventListener('click', function() {
            const activeDrawer = document.querySelector('.product-drawer-overlay.active');
            const container = activeDrawer ? activeDrawer.querySelector('.products-container') : null;
            if (container) container.scrollLeft -= 10;
        });
    });
    
    scrollRightButtons.forEach(button => {
        button.addEventListener('click', function() {
            const activeDrawer = document.querySelector('.product-drawer-overlay.active');
            const container = activeDrawer ? activeDrawer.querySelector('.products-container') : null;
            if (container) container.scrollLeft += 10;
        });
    });

    document.querySelectorAll('.lookbook__product-hotspot').forEach((hotspot, index) => {
        // apply on mobile only
        hotspot.addEventListener('click', function(e) {
            if (window.innerWidth < 768) {
                if (this.classList.contains('active')) {
                    return;
                }
                e.stopPropagation();
                e.preventDefault();
                document.querySelectorAll('.lookbook__product-hotspot').forEach(spot => {
                    spot.classList.remove('active');
                    spot.blur();
                });
                this.classList.add('active');
                this.focus();
            }
        });
    });
});